/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_themeBase/_helpers";

const setTooltip = (content) => (
    <Popover
        // placement="left"
        // positionLeft={200}
        // positionTop={50}
        className="mytooltip"
        style={{
            boxShadow: "-1px 2px 20px rgba(1,0,1,0.5)",
            // position: 'fixed',
            // // color: 'green',
            maxWidth: "70%",
            wordBreak: 'break-all',
            backgroundColor: '#bbccff',
        }}>
        <Popover.Content>{content}</Popover.Content>
    </Popover>
);

export const ShowGroupWithSubsColumnFormatter = (cellContent, row) => (
    <div className="float-left border-0 ">
        {row && row.groups && row.groups.map((group) => (
            <>
                <span className="border-0" key={group.id}>
                    <OverlayTrigger
                        key={group.id}
                        overlay={setTooltip(group.subTitles)}
                    // placement="bottom"
                    //style={{ marginBottom: "50px", marginTop: "50px", marginRight: "50px", marginLeft: "50px" }}
                    >
                        <span className=" label-light-success label-inline">
                            {group.title}
                        </span>
                    </OverlayTrigger>
                </span>

                {/* <span className="border-0" key={group.id}>
                    <OverlayTrigger
                        overlay={<Tooltip style={{
                            position: 'absolute',
                            backgroundColor: 'rgba(1, 1, 1, 0.5)',
                            padding: '5px 15px',
                            color: 'green',
                            borderRadius: 3
                        }} id="">{group.subTitles} </Tooltip>}
                    >
                        <span className=" label-light-success label-inline">
                            {group.title}
                        </span>
                    </OverlayTrigger>
                </span> */}

                {/* < span
                    className={`label label-lg label-light-success label-inline`
                    }
                >
                    {group.title}
                </span > */}
                {" , "}
            </>
        ))}


        {/* 
        <div className="list-timeline-item mb-3" key={object.id}>
            <span className="list-timeline-text">
                <span
                    className={`label label-lg label-light-${ObjectStatusCssClasses[+object.isDeleted]
                        } label-inline`}
                    style={{ width: "60px" }}
                >
                    {object.id}
                </span>{" "}
                <span className="ml-5">
                    {object.title}
                </span>
            </span>
        </div> */}



    </div >
);
